export interface OrgScenarioRecord {
  id: string;
  tenantId: string;
  strategyId: string;
  asIsOrgStateId: string;
  toBeOrgStateId: string;
  name: string;
  description?: string | null;
  isActive: boolean;
  toBeSource?: string | null;
  toBePatternRunId?: string | null;
  toBePatternId?: string | null;
  toBePatternName?: string | null;
  toBePatternLibraryVersion?: string | null;
  toBeVersionNumber?: number | null;
  toBeSavedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OrgScenarioCurrent {
  /** Actual baseline identity for operator readback; absent on older API builds. No roster data. */
  baselineBinding?: {
    tenantId: string;
    strategyId: string;
    strategyOrgContextId: string | null;
    matchesRequestedStrategy: boolean;
    baseline: {
      orgStateId: string;
      tenantId: string;
      type: string;
      strategyId: string | null;
      orgContextId: string | null;
    } | null;
  };
  asIsOrgStateId: string | null;
  toBeOrgStateId: string | null;
  activeScenario: OrgScenarioRecord | null;
}

export interface CreateOrgScenarioPayload {
  strategyId: string;
  asIsOrgStateId: string;
  toBeOrgStateId: string;
  name?: string;
  description?: string | null;
}

export interface UpdateOrgScenarioPayload {
  strategyId: string;
  name?: string;
  description?: string | null;
}

export { orgStateMatchesStrategy } from './org-state-strategy-binding';
